import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, Mail, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { COMPANY } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Επιτυχής σύνδεση");
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Σφάλμα σύνδεσης");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 grid-bg relative">
      <Link
        to="/"
        className="absolute top-6 left-6 text-[#A1A1AA] hover:text-white text-sm flex items-center gap-2 font-mono-th"
        data-testid="back-to-site"
      >
        <ArrowLeft size={14} /> ΕΠΙΣΤΡΟΦΗ
      </Link>

      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <img
            src={COMPANY.logo}
            alt="Technological Horizons"
            className="h-14 w-auto mx-auto mb-4"
          />
          <div className="overline">Admin Panel · Σύνδεση</div>
          <h1 className="font-heading text-3xl text-white mt-2 font-medium tracking-tight">
            Διαχείριση Πύλης
          </h1>
        </div>

        <form
          onSubmit={onSubmit}
          data-testid="admin-login-form"
          className="bg-[#0F0F11] border border-[#27272A] p-8 space-y-6"
        >
          <div>
            <label className="block font-mono-th text-[10px] uppercase tracking-[0.2em] text-[#A1A1AA] mb-2">
              Email
            </label>
            <div className="relative">
              <Mail
                size={16}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A1A1AA]"
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="admin-email-input"
                className="input-th w-full pl-10 pr-4 py-3 text-sm rounded-none"
                placeholder="admin@techorizons.gr"
              />
            </div>
          </div>

          <div>
            <label className="block font-mono-th text-[10px] uppercase tracking-[0.2em] text-[#A1A1AA] mb-2">
              Κωδικός
            </label>
            <div className="relative">
              <Lock
                size={16}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-[#A1A1AA]"
              />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="admin-password-input"
                className="input-th w-full pl-10 pr-4 py-3 text-sm rounded-none"
                placeholder="••••••••"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="btn-primary w-full py-3.5 text-sm font-medium inline-flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {submitting ? (
              <>
                <Loader2 size={16} className="animate-spin" /> Σύνδεση...
              </>
            ) : (
              "Σύνδεση"
            )}
          </button>
        </form>

        <p className="text-center text-xs font-mono-th text-[#A1A1AA] mt-6">
          Ασφαλής σύνδεση · JWT Bearer Token
        </p>
      </div>
    </div>
  );
}
